import { useQuery } from '@tanstack/react-query';
import { API_ROLE } from '../../api/role';
import { API_USER } from '../../api/user';
import Loader from '../../components/common/loader';
import UsersGroupsTables from '../../components/users-table/UsersGroupsTables';
import { RoleTableData } from '../../components/users-table/types';
import { useAuthContext } from '../../context/AuthContext';
import { Roles } from '../../types';
import { decrypt } from '../../utils/cryptojs-helper';

const UsersPage = () => {
  const { userNew } = useAuthContext();
  const decrypted = userNew ? decrypt(userNew) : '';
  let user: any = null;
  if (decrypted) {
    try {
      user = JSON.parse(decrypted);
    } catch (_e) {
      user = null;
    }
  }

  const isValidUser = Boolean(user?.currentClient?.client?.id);

  // pass different url based off if admin or not. If admin get all users, else get only users by current client
  let url = isValidUser ? `user/client/${user.currentClient.client.id}` : '/user';
  const isAdmin = isValidUser ? user.currentClient.client.roles.includes(Roles.ADMIN) : false;
  if (isAdmin) {
    url = '/user';
  }
  // pass arg to function by passing through second argument an array - (queryKey)
  const {
    error: usersError,
    data: usersData,
    isLoading: usersLoading,
  } = useQuery(['GetAllUsers', url], API_USER.getAll, { enabled: isValidUser });

  const { data: fetchedRoles, isLoading: rolesLoading } = useQuery(
    ['GetAllRoles'],
    () => API_ROLE.getAll(),
    { enabled: isValidUser && isAdmin }
  );

  const currentRoles: RoleTableData[] = isAdmin
    ? (fetchedRoles || []).map((role) => ({
        id: role.id,
        name: role.name,
        code: role.code,
      }))
    : [];

  if (!decrypted) return <p>Unable to load user details. Please log in again.</p>;
  if (!isValidUser) return <p>Unable to parse user details. Please log in again.</p>;

  if (usersError) return <p>Error loading users</p>;
  if (usersLoading || (isAdmin && rolesLoading)) return <Loader />;

  if (usersData) {
    return <UsersGroupsTables loggedUser={user} usersData={usersData} rolesData={currentRoles} />;
  }

  return <Loader />;
};

export default UsersPage;
